import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  useDocumentMeta({
    title: "页面不存在 - 51-每日大赛",
    description: "你访问的页面不存在或已被移除，返回首页继续浏览每日赛事资讯与今日黑榜mdrs排行。",
  });

  return (
    <Layout>
      <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="flex h-24 w-24 items-center justify-center rounded-full bg-primary-100 text-5xl font-extrabold text-primary-700">
          404
        </span>
        <h1 className="mt-6 text-2xl font-extrabold text-foreground-950 md:text-3xl">页面走丢了</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面不存在、链接已失效或赛事已下架。可以返回首页，或直接前往今日黑榜查看最新排行。
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/blacklist"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-200 bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-50"
          >
            <i className="ri-fire-line"></i>
            查看今日黑榜
          </Link>
        </div>
      </div>
    </Layout>
  );
}